import React, { useEffect, useState } from "react";
import Sidebar from "../Header/Sidebar/index";
import Navbar from "../Header/Navbar/index";

//Material Components
import Box from "@material-ui/core/Box";
import Header from "../Header/index";
import CircularProgress from '@material-ui/core/CircularProgress';
import {useWallet} from '../../context/walletProvider'
const BaseLayout = (props) => {
  const [isOpen, setisOpen] = useState(false);
  const [isLoading,setIsLoading] = useState(false)
  const toggle = () => {
    setisOpen(!isOpen);
  };
  const wallet = useWallet()
  useEffect(()=>{
    setIsLoading(wallet.isLoading)
  },[wallet])
  const { children } = props;
  return (
    <>
      <Header style={{ marginTop: "0%" }} />
      {children}
      <div className="loader">
        {(isLoading)?<CircularProgress/>:''}
      </div>
    </>
  );
};

export default BaseLayout;
